export const FETCH_OFFPLAN_BUYER = 'FETCH_OFFPLAN_BUYER';
export const FETCH_OFFPLAN_BUYER_SUCCESS = 'FETCH_OFFPLAN_BUYER_SUCCESS';
export const FETCH_OFFPLAN_BUYER_ERROR = 'FETCH_OFFPLAN_BUYER_ERROR';

export const FETCH_PRIMARY_CONTACT = 'FETCH_PRIMARY_CONTACT';
export const FETCH_PRIMARY_CONTACT_SUCCESS = 'FETCH_PRIMARY_CONTACT_SUCCESS';
export const FETCH_PRIMARY_CONTACT_ERROR = 'FETCH_PRIMARY_CONTACT_ERROR';

export const ADD_PRIMARY_CONTACT = 'ADD_PRIMARY_CONTACT';
export const ADD_PRIMARY_CONTACT_SUCCESS = 'ADD_PRIMARY_CONTACT_SUCCESS';
export const ADD_PRIMARY_CONTACT_ERROR = 'ADD_PRIMARY_CONTACT_ERROR';

export const REMOVE_PRIMARY_CONTACT = 'REMOVE_PRIMARY_CONTACT';
export const REMOVE_PRIMARY_CONTACT_SUCCESS = 'REMOVE_PRIMARY_CONTACT_SUCCESS';
export const REMOVE_PRIMARY_CONTACT_ERROR = 'REMOVE_PRIMARY_CONTACT_ERROR';
